var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeetingAndFunctionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 195,
    height: 195,
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.425,
    height: 78.227,
    fill: "#104864"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-401 -1373.998)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 97.5,
    r: 97.5,
    transform: "translate(401 1373.998)",
    fill: "#e9f2f0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(453.751 1440.01)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.612,81.237a1.068,1.068,0,0,0,1.007,1.065H125.4a1.067,1.067,0,0,0,1.066-1.066V66.493a1.068,1.068,0,0,0-1.066-1.066h-6.722a1.068,1.068,0,0,0-1.067,1.066Zm2.133-13.68h4.59V80.174h-4.59Z",
    transform: "translate(-54.336 -30.227)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.34,77.228a1.06,1.06,0,0,0,.754.312h6.722a1.068,1.068,0,0,0,1.066-1.067v-20.3a1.068,1.068,0,0,0-1.066-1.064h-6.722a1.069,1.069,0,0,0-1.067,1.046V76.474a1.059,1.059,0,0,0,.312.754m1.821-19.984h4.59V75.41h-4.59Z",
    transform: "translate(-63.305 -25.462)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.42,47.506h12a1.066,1.066,0,0,0,0-2.133h-12a1.066,1.066,0,0,0,0,2.133",
    transform: "translate(-54.679 -20.962)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.192,86.255a1.067,1.067,0,0,0,1.066,1.066h6.722a1.068,1.068,0,0,0,1.061-1.065v-8.9a1.069,1.069,0,0,0-1.063-1.064H99.258a1.069,1.069,0,0,0-1.066,1.062Zm2.133-7.835h4.59v6.774h-4.59Z",
    transform: "translate(-45.364 -35.246)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.024,90.2h10.5a1.066,1.066,0,1,0,0-2.133h-10.5a1.066,1.066,0,0,0,0,2.133",
    transform: "translate(-28.624 -40.686)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.42,37.373h12a1.066,1.066,0,0,0,0-2.132h-12a1.066,1.066,0,1,0,0,2.132",
    transform: "translate(-54.679 -16.281)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.958,80.854a1.067,1.067,0,0,0,1.066,1.066H73.529a1.066,1.066,0,1,0,0-2.132H63.024a1.067,1.067,0,0,0-1.066,1.066",
    transform: "translate(-28.624 -36.861)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.417,25.112h-12a1.066,1.066,0,1,0,0,2.132h12a1.066,1.066,0,0,0,0-2.132",
    transform: "translate(-54.679 -11.602)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.826,46.82A12.471,12.471,0,0,0,83,34.5v-.147A12.5,12.5,0,0,0,70.521,21.861c-.292,0-.581.009-.867.029h0c.018,0-.017.013-.064.017a12.47,12.47,0,0,0-9.408,19.441l.36.531.5.583a12.53,12.53,0,0,0,8.786,4.358m.963-22.8h.269c.1,0,.2.006.3.014h0c.136.012.272.025.407.04.2.025.393.055.586.09.131.023.263.047.394.075.192.041.383.094.572.147l.113.032c.083.023.168.046.257.073.2.064.382.136.569.209l.106.04c.08.029.158.059.236.091.188.082.369.173.548.264.276.141.507.27.731.407l.073.042c.1.056.2.113.284.175.119.079.238.17.357.26l.2.147c.063.047.127.094.185.142.168.134.331.279.493.427l.181.165c.176.169.339.338.5.512l.129.143c.167.187.327.383.479.585l.071.1c.165.222.321.448.467.681a10.521,10.521,0,0,1,1.508,4.3l.036.3H70.789ZM60.2,35.292a10.351,10.351,0,0,1,8.126-11.06l.326-.07V34.54a1.075,1.075,0,0,0,.312.754,1.062,1.062,0,0,0,.754.313H80.793l-.047.31A10.349,10.349,0,0,1,70.516,44.7c-.106,0-.211,0-.317,0a10.351,10.351,0,0,1-9.994-9.4",
    transform: "translate(-26.812 -10.1)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.773,36.065a8.027,8.027,0,0,0,0,16.055h0a8.027,8.027,0,0,0,0-16.055m4.168,12.2A5.893,5.893,0,1,1,12.77,38.2h0a5.9,5.9,0,0,1,4.167,10.063",
    transform: "translate(-2.192 -16.662)",
    fill: "#104864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.628,55.813V9.367l.251-.017a2.736,2.736,0,0,0,2.546-2.72V2.742A2.743,2.743,0,0,0,87.685,0h-63.1a2.744,2.744,0,0,0-2.74,2.741V6.63a2.735,2.735,0,0,0,2.546,2.719l.251.017V32.895l-7.445,4.321H3.352A3.358,3.358,0,0,0,0,40.57v16.8a3.343,3.343,0,0,0,3.051,3.317l.245.022V71.925a6.309,6.309,0,0,0,6.3,6.3h1.963a6.312,6.312,0,0,0,6.3-6.3V60.707l.245-.022a3.343,3.343,0,0,0,3.051-3.321V45.04l3.478-2.018V55.813A1.067,1.067,0,0,0,25.7,56.88H55.068v6.475l-.218.043a6.75,6.75,0,1,0,2.568,0l-.218-.043V56.88H86.562a1.067,1.067,0,0,0,1.066-1.066M24.581,7.238a.61.61,0,0,1-.607-.6V2.742a.61.61,0,0,1,.6-.608H87.685a.61.61,0,0,1,.607.605v3.9a.608.608,0,0,1-.6.6Zm-8.85,64.689a4.175,4.175,0,0,1-4.17,4.169H9.6a4.174,4.174,0,0,1-4.169-4.169V60.72h10.3Zm3.3-28.115V57.367a1.21,1.21,0,0,1-.357.862,1.226,1.226,0,0,1-.862.357H3.353a1.228,1.228,0,0,1-1.219-1.215v-16.8a1.227,1.227,0,0,1,1.215-1.218H17.767L28.877,32.9a2.332,2.332,0,0,1,1.833-.214,1.943,1.943,0,0,1,1.2.976,2.342,2.342,0,0,1-.782,3.127ZM59.4,66.756a4.594,4.594,0,0,1,1.355,3.265h0A4.622,4.622,0,1,1,59.4,66.756m26.1-12.01H26.771V41.785l5.421-3.141a4.443,4.443,0,0,0,1.632-5.918.5.5,0,0,1-.045-.076l-.237-.508-.579-.546a4.148,4.148,0,0,0-1.641-.951,4.5,4.5,0,0,0-3.516.413l-1.035.6V9.37H85.5Z",
    fill: "#104864"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingAndFunctionIcon);
export default __webpack_public_path__ + "static/media/MeetingAndFunctionIcon.c0f5c05ad0225c34187d7fd7c4e2b3ed.svg";
export { ForwardRef as ReactComponent };